const routes = [
  {
    index: true,
    label: 'Giuseppe Maldarelli',
    path: '/',
  },
  {
    label: 'Su di me',
    path: '/about',
  },
  {
    label: 'CV',
    path: '/resume',
  },
  {
    label: 'Progetti',
    path: '/projects',
  },
  {
    label: 'Skills',
    path: '/skills',
  },
  {
    label: 'Contattami',
    path: '/contact',
  },
];

export default routes;
